
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import BorderBox from "@src/components/BorderBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuTakeoutPancakeTakeoutPancakeTopImage } from "@src/constants/images";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
import { meta as pancakePageMeta } from "./pancake.mdx";
export const meta = {
  path: "/media/harajuku/takeout_pancake",
  title: "【原宿・表参道】甘いパンケーキのテイクアウト ができるお店５選！",
  description: "原宿・表参道エリアで甘いスイーツパンケーキがテイクアウトできるお店をまとめてみました！個人の有名なお店やあのハワイの人気店のメニューを、テイクアウトに限定して写真、値段付きで公開！Uber Eatsを実施しているお店もあるので、ご確認ください！",
  topImg: harajukuTakeoutPancakeTakeoutPancakeTopImage,
  author: murakamiMasanori,
  tags: ["行列店", "原宿", "人気店", "パンケーキ", "まとめ記事", "食べログ高評価", "テイクアウト", "行列情報"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道エリアで甘いスイーツパンケーキがテイクアウトできるお店をまとめてみました！`}</p>
    <p>{`個人の有名なお店やあのハワイの人気店のメニューをテイクアウトに限定してご紹介します！また、Uber Eats の有無や、メニューを写真・値段付きで公開しております！`}</p>
    <p>{`原宿・表参道にお越しの際は、ぜひチェックしてください！`}</p>
    <h2>{`ミカサデコカフェ(MICASADECO & CAFE)`}</h2>
    <InstaImage postId="B9qDzXqguvS" mdxType="InstaImage" />
    <p>{`東京、大阪、京都に３店舗を構えるパンケーキの人気店で、原宿店が 2020 年 3 月に神宮前に場所を移転してリニューアルオープンしたばかり！
1 番人気のパンケーキだけでなく、月替りのランチメニューなど、素材にこだわった食事が食べられるお店として人気上昇中！`}</p>
    <h3>{`テイクアウトメニュー`}</h3>
    <h4>{`もちもちプレーンパンケーキ(900 円)`}</h4>
    <InstaImage postId="B-uAnlyBClT" mdxType="InstaImage" />
    <p>{`シンプルだけどしっかり味がついていて、何よりもふわふわなパンケーキ！
このパンケーキを求めて、原宿店舗では行列ができています。
これがテイクアウトで食べられるなんて…！`}</p>
    <h4>{`ココナッツカスタードパンケーキ(税込：1,200 円)`}</h4>
    <InstaImage postId="BPpg5PfBlsz" mdxType="InstaImage" />
    <p>{`濃厚なカスタードと甘いココナッツの風味が、ふわふわのパンケーキと合わさった人気メニュー！
こちらも通常メニューとして販売しているメニューがテイクアウトに！`}</p>
    <h4>{`グラノーラパンケーキ(税込：1,250 円)`}</h4>
    <InstaImage postId="BU6gMylh5dH" mdxType="InstaImage" />
    <p>{`パンケーキの生地に、なんとグラノーラが練りこまれた一品！
外のお店では中々みたことのないような一品で、フワッとした食感にグラノーラのカリッとした食感が楽しめる一品！
テイクアウトで楽しめるのは嬉しい…！`}</p>
    <h4>{`ブランチパンケーキセット(税込：1,300 円)`}</h4>
    <InstaImage postId="B_3030kA7EP" mdxType="InstaImage" />
    <p>{`テイクアウト用にランチメニューとして作られた、お食事よりのパンケーキ！
ソーセージ、オムレツ、ヨーグルトなど、ボリューム感のあるパンケーキになっています！`}</p>
    <h3>{`Uber Eats がスタート！`}</h3>
    <InstaImage postId="B_0_hengxBj" mdxType="InstaImage" />
    <p>{`2020 年 5 月 7 日から、Uber Eats がスタートしました！
エリアは限定的ですが、原宿・表参道エリア付近にお住まいの方は、ご自宅でもこの味が楽しめるので、ぜひ Uber Eats を使ってみてください！`}</p>
    <h3>{`注文はお電話で！`}</h3>
    <p>{`事前に電話をして来店時間をお伝えしておけば、待たずに温かいパンケーキが受け取れると思います！`}</p>
    <p>{`ミカサデコ&カフェ 神宮前店：03-6803-8630`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`神宮前のキャットストリートに位置するお店で、神宮前から徒歩ですぐ行くことができます！
休日はすごい行列ができているので、すぐに見つけることができると思います！`}</p>
    <GoogleMap lat={35.6665261} lng={139.7032377} mdxType="GoogleMap" />
    <hr></hr>
    <p>{`詳細が気になる方はこちらのページもオススメ！`}</p>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`クリスクロス(crisscross)`}</h2>
    <InstaImage postId="B5MhJ0CpO0t" mdxType="InstaImage" />
    <p>{`表参道のモーニングで絶対外せないパンケーキの人気店「クリスクロス 」。
開放感のある自然に囲まれたテラス席や、暗く照明がオレンジ色落とされた落ち着きのある店内を求めてご来店される方も多いです。`}</p>
    <h3>{`テイクアウトができるパンケーキはこちら！`}</h3>
    <p>{`クリスクロスは早い段階からパンケーキのテイクアウトを始めていて、行列に並ばなくても家でゆっくり食べることができます！
表参道、原宿、青山など、いろんなエリアからお客さんが来ているのもそういった理由があるのだと思います！`}</p>
    <h3>{`クラシックバターミルクパンケーキ(税込：1,100 円)`}</h3>
    <InstaImage postId="B--w2QTAba5" mdxType="InstaImage" />
    <p>{`バターがたっぷり中央に乗ったベーシックなパンケーキになります。
三枚というボリューム感もしっかりある`}<strong parentName="p">{`もちもち`}</strong>{`したパンケーキで、食べ応えがある一品！`}</p>
    <h4>{`パンケーキテイクアウトはこんな感じに！`}</h4>
    <InstaImage postId="B-9Od0PlUzd" mdxType="InstaImage" />
    <p>{`ほとんどテイクアウトメニューと店内のメニューが変わらないクオリティー！すごい。`}</p>
    <h3>{`バターミルクパンケーキ　ソーセージ、フライドエッグ (税込：1,400 円)`}</h3>
    <p><strong parentName="p">{`※11 時以降は税込：1,700 円に`}</strong></p>
    <InstaImage postId="B_4d7DvHw4P" mdxType="InstaImage" />
    <p>{`クリスクロスの 1 番の人気メニューで、インスタにもたくさん写真が上がっているメニューです！
こちらに乗っているソーセージはなんと`}<strong parentName="p">{`自家製`}</strong>{`だそう。
甘いパンケーキと塩気のあるソーセージとフライドエッグは相性抜群で、モーニングメニューでよく注文される方が多いそうです…！`}</p>
    <h3>{`注文はお電話で！`}</h3>
    <p>{`事前に電話をして来店時間をお伝えしておけば、待たずに温かいパンケーキが受け取れると思います！`}</p>
    <p>{`クリスクロス(crisscross)：03-6434-1266`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道駅から`}<strong parentName="p">{`徒歩２分`}</strong>{`の好立地で、アクセス抜群！
原宿駅からも徒歩 10 分程度でアクセスできるので、山手線沿線を使う方も簡単にいくことができるエリアになっています！`}</p>
    <GoogleMap lat={35.6629453} lng={139.7104083} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`リズラボキッチン(Riz Labo Kitchen)`}</h2>
    <p>{`無農薬の米粉と平飼卵を使った素材にこだわるパンケーキの人気店がリズラボキッチン。
裏参道と呼ばれる最近人気のエリアで、古民家のような建物にお店を構えるリズラボキッチンのふわふわパンケーキがご自宅で楽しめるようになったそうです！`}</p>
    <p><strong parentName="p">{`こちらが古民家風の裏参道エリアの入り口`}</strong></p>
    <InstaImage postId="Bw_LbbhnrmC" mdxType="InstaImage" />
    <h3>{`北海道産濃厚生クリームパンケーキサンド(税込 1,760 円)　`}</h3>
    <p><strong parentName="p">{`テイクアウト 限定`}</strong>{`のメニューとして、４月からスタートしたこちらのメニュー！
ふわふわのパンケーキの食感をテイクアウトでも楽しめるそう！`}</p>
    <InstaImage postId="B_cMlHuA8Lm" mdxType="InstaImage" />
    <p>{`米粉 100%グルテンフリーのパンケーキがサンド型になって、
サンドが食べやすいサイズで`}</p>
    <InstaImage postId="B_qlpsYgKQn" mdxType="InstaImage" />
    <h3>{`オンライン販売(テイクアウト ができない方向け)`}</h3>
    <p>{`オンライン販売が 2020 年 4 月頃からスタートしたそうなので、全国どこでもリズラボキッチンの米粉グルテンフリーパンケーキが食べられるようになりました！
オンライン販売では限定のパンケーキメニューや、米粉も販売しているそうで、ご自宅で作ってみたい方は他のメニューも購入してみてください！`}</p>
    <p>{`◼︎ 予約・購入ができるサイトはこちら ↓`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.rizlabo.com/web-shop/"
      }}>{`https://www.rizlabo.com/web-shop/`}</a></p>
    <hr></hr>
    <h2>{`エッグシングス(Egg’n Things)`}</h2>
    <p>{`日本にパンケーキを広めた元祖ハワイ発祥のお店で、“All Day Breakfast”を掲げ、ハワイと日本を問わずボリューム感のあるハワイアンパンケーキが食べられます！`}</p>
    <InstaImage postId="B-v71ZDH5Rd" mdxType="InstaImage" />
    <h3>{`パンケーキ(税込：748 円)`}</h3>
    <InstaImage postId="B_1GmLpACyx" mdxType="InstaImage" />
    <p>{`エッグシングス(Egg’n Things)のベーシックなパンケーキで、しっかり甘味のあるパンケーキになっています！
何よりも他のお店とは異なって、価格がリーズナブルな点も魅力的です！`}</p>
    <h4>{`フルーツとシロップが選べる`}</h4>
    <p>{`パンケーキを注文すると、下記のフルーツが選べるようになっています！`}</p>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      フルーツ：ストロベリー/バナナ/パイナップル/マンゴー
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      シロップ：メープル/グァバ/ココナッツ
    </Text>
  </Text>
    </BorderBox>
    <h3>{`宇治抹茶パンケーキ(税込：748 円)`}</h3>
    <InstaImage postId="B3OrZuig0WQ" mdxType="InstaImage" />
    <p>{`エッグシングス(Egg’n Things)のスペシャルパンケーキとして、限定でテイクアウトができるメニューです！
黒蜜とあずきがふんだんに使われているパンケーキになります！`}</p>
    <p>{`しかし、テイクアウトだと`}<strong parentName="p">{`クリームがつかない`}</strong>{`、`}<strong parentName="p">{`フルーツとシロップは選べない(元々ついている)`}</strong>{`ので、こちらだけご注意ください！`}</p>
    <h3>{`Uber Eats がスタート！`}</h3>
    <InstaImage postId="B-efY79n_6A" mdxType="InstaImage" />
    <p>{`エッグシングス(Egg’n Things)を Uber Eats で注文することができます！
エリアは限定的ですが、原宿・表参道エリア付近にお住まいの方は、ご自宅でもこの味が楽しめるので、ぜひ Uber Eats を使ってみてください！
関西のエリア、横浜のエリアなどでも実施しているそうなので、確認してみてください！`}</p>
    <h3>{`事前に web か電話で予約を！`}</h3>
    <p>{`事前に予約をしておけば、待たずにパンケーキが受け取れると思いますので、こちらからご確認ください！
`}<a parentName="p" {...{
        "href": "https://www.eggsnthingsjapan.com/harajuku/"
      }}>{`https://www.eggsnthingsjapan.com/harajuku/`}</a></p>
    <hr></hr>
    <h2>{`NUMBER A`}</h2>
    <p>{`オープンしてから 10 年経つお店で、メインはパスタなどの食事系が大人気のお店です！
食事系のパンケーキはもちろんですが、甘いパンケーキも提供されています。
テイクアウトを早い段階から始めていたお店としても知られていますが、今回は甘いパンケーキをご紹介させていただきます...！`}</p>
    <h3>{`シンプルパンケーキ(税込：880 円)`}</h3>
    <InstaImage postId="B3XGXUWnCNP" mdxType="InstaImage" />
    <p>{`大きな二枚のパンケーキの上にたっぷりのバターが載っているクラシカルなパンケーキになります！
表参道エリアのクリスクロスのパンケーキに近く、モチッとした食感が楽しめる一品！
通常メニューとして提供されていますが、テイクアウトも可能な一品です！`}</p>
    <p>{`他のパンケーキ店と比べても`}<strong parentName="p">{`価格帯が非常にリーズナブル`}</strong>{`なのが魅力!`}</p>
    <h3>{`ダブルベリーパンケーキ(税込：990 円)`}</h3>
    <InstaImage postId="B_Y6AxjlzFN" mdxType="InstaImage" />
    <p>{`シンプルパンケーキにたっぷりのベリーがトッピングされたパンケーキになります！
こちらも通常メニューにありますが、テクアウトもできるメニューとなっているので、甘いパンケーキをガッツリ食べたい方にはオススメになっています。`}</p>
    <h3>{`事前に電話で確認を！`}</h3>
    <p>{`テイクアウトのメニューが売り切れていないか、事前に注文はできるかなどこちらで気になった方はチェックしてみてください...！
NUMBER A：03-6427-4038`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道駅 B1,B2 出口から`}<strong parentName="p">{`徒歩 2 分`}</strong>{`というアクセス抜群のお店になっています！`}</p>
    <GoogleMap lat={35.6643153} lng={139.708938} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿・表参道エリアでパンケーキの人気店でテイクアウトができるお店をご紹介しました！
Uber Eats ができるお店もコロナの影響もあって徐々に増えてきているので、ご自宅でもパンケーキを楽しんでみてください！`}</p>
    <hr></hr>
    <p>{`関連記事`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;